export const ROUTES = {
  // Public routes
  LOGIN: '/login',
  RECOVERY: '/recovery',
  RECOVERY_VERIFY: '/recovery/:id',
  
  // Protected routes
  DASHBOARD: '/',
  AGENTS: '/agents',
  AGENT_DETAIL: '/agents/:id',
  AGENT_NEW: '/agents/new',
  TERMINAL: '/terminal/:subdomain',
  
  // Settings
  SETTINGS: '/settings',
  SETTINGS_PROFILE: '/settings/profile',
  SETTINGS_PASSKEYS: '/settings/passkeys',
  SETTINGS_TOTP: '/settings/totp',
  SETTINGS_PHONE: '/settings/phone',
  SETTINGS_SESSIONS: '/settings/sessions',
  SETTINGS_PREFERENCES: '/settings/preferences',
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];

/**
 * Build a route path with parameters
 * @example buildRoute(ROUTES.AGENT_DETAIL, { id: '123' }) => '/agents/123'
 */
export function buildRoute(
  route: string,
  params: Record<string, string>
): string {
  let result = route;
  for (const [key, value] of Object.entries(params)) {
    result = result.replace(`:${key}`, encodeURIComponent(value));
  }
  return result;
}

/**
 * Navigation items for sidebar
 */
export const NAV_ITEMS = [
  { path: ROUTES.DASHBOARD, label: 'Dashboard', icon: 'home' },
  { path: ROUTES.AGENTS, label: 'Agents', icon: 'server' },
  { path: ROUTES.SETTINGS, label: 'Settings', icon: 'settings' },
] as const;
